import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesIndirectModel } from './types';
import { foreignActivitiesIndirectItemValidator } from './validators/item';

const foreignActivitiesIndirectValidator: ValidateJSModel<ForeignActivitiesIndirectModel> = {
  HasInterests: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasInterests?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignActivitiesIndirectItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesIndirectValidator;
